import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { Menu, MenuItem, Typography } from '@material-ui/core'
import React, { useCallback } from 'react'
import { HiBars3BottomLeft, HiPlus } from 'shared/HarmonyIcon'
import { getCycledIndex, useCaptureKeydown } from './hooks/useMenuKeyboardNav'
import { TaskAnchorContext } from './useTasksPopover'

export interface TasksSubmenuProps {
    open: boolean
    anchorEl: Element | null
    onClose: () => void
    onCloseMainMenu: () => void
    openTasksWindow: (params?: Record<string, string>) => void
    taskAnchorContext: TaskAnchorContext | null
    menuTextClass: string
}

const TasksSubmenu = ({
    open,
    anchorEl,
    onClose,
    onCloseMainMenu,
    openTasksWindow,
    taskAnchorContext,
    menuTextClass,
}: TasksSubmenuProps) => {
    // MUI v4 Menu only handles Arrow keys; Tab fights overlapping Modal focus sentinels.
    // Intercept Tab in capture phase and cycle focus between the two menu items ourselves.
    const handleTabCycle = useCallback((e: KeyboardEvent) => {
        if (e.key !== 'Tab') return
        const paper = (document.activeElement as HTMLElement)?.closest(
            '.MuiPopover-paper'
        ) as HTMLElement | null
        if (!paper) return
        const items = Array.from(
            paper.querySelectorAll<HTMLElement>(
                '[role="menuitem"]:not([aria-disabled="true"])'
            )
        )
        if (!items.length) return
        e.preventDefault()
        e.stopPropagation()
        const currentIdx = items.indexOf(document.activeElement as HTMLElement)
        items[getCycledIndex(currentIdx, items.length, e.shiftKey)].focus()
    }, [])

    useCaptureKeydown(open, handleTabCycle)

    return <Menu
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        getContentAnchorEl={null}
        PaperProps={{
            style: {
                marginLeft: 4,
                borderRadius: 10,
                border: '1px solid #E2E8F0',
                boxShadow: '0 12px 30px rgba(15,23,42,0.18)',
                minWidth: 168,
                padding: '5px',
            },
        }}
    >
        <MenuItem
            onClick={() => {
                openTasksWindow()
                onClose()
                onCloseMainMenu()
            }}
            style={{ borderRadius: 7, gap: 10, padding: '9px 11px', fontSize: pxToRem(13) }}
        >
            <HiBars3BottomLeft size={16} color="#4C92D9" />
            <Typography component="span" className={menuTextClass}>
                All Tasks
            </Typography>
        </MenuItem>
        <MenuItem
            onClick={() => {
                const params: Record<string, string> = { openCreate: 'true' }
                if (taskAnchorContext) {
                    params.noteType = taskAnchorContext.noteType
                    if (taskAnchorContext.contentItemId) params.contentItemId = taskAnchorContext.contentItemId
                    if (taskAnchorContext.projectElementId) params.projectElementId = taskAnchorContext.projectElementId
                    if (taskAnchorContext.projectElementDescription) params.projectElementDescription = taskAnchorContext.projectElementDescription
                    if (taskAnchorContext.isProductTypeProperty) params.isProductTypeProperty = 'true'
                    if (taskAnchorContext.projectProductFamilyId) params.projectProductFamilyId = taskAnchorContext.projectProductFamilyId
                }
                openTasksWindow(params)
                onClose()
                onCloseMainMenu()
            }}
            style={{ borderRadius: 7, gap: 10, padding: '9px 11px', fontSize: pxToRem(13) }}
        >
            <HiPlus size={16} strokeWidth={2} color="#4C92D9" />
            <Typography component="span" className={menuTextClass}>
                Create Task
            </Typography>
        </MenuItem>
    </Menu>
}

export default TasksSubmenu
